import React from "react";
import { CtaButton } from "./CtaButton";
const needs = ["What to review.", "What to decide.", "In what order.", "And what needs to be defined before you start."];
export function FinalCta() {
  return <section className="bg-plum-900 px-5 py-16 text-white md:py-24" data-id="element-117" data-mp="19f7dd1p407bs">
      <div className="mx-auto max-w-2xl text-center" data-id="element-118" data-mp="15ddija1lhxjj">
        <h2 className="font-display text-[32px] font-extrabold leading-tight md:text-5xl" data-id="element-119" data-mp="15bsnljbdccl5">
          Ready to stop analyzing every case <em className="text-gold" data-id="element-120" data-mp="1jasbgor24ng9">from scratch?</em>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-plum-100" data-id="element-121" data-mp="1ed8uvi6vzyl5">
          Start using a structured system to organize your implant decisions before surgery. You don't necessarily need
          another massive library of theory. You need to know:
        </p>
        <ul className="mt-6 space-y-2 font-display text-2xl font-bold" data-id="element-122" data-mp="2233au8mi639m">
          {needs.map(n => <li key={n} data-id="element-123" data-mp="1x5b62e0remo0">{n}</li>)}
        </ul>
        <div className="mt-10" data-id="element-124" data-mp="1x2gp4wgyfjzc">
          <CtaButton tone="dark" label="Get Implant Decision System™" sub="Just $27 · One-time payment · Instant access · 7-Day Guarantee" data-id="element-125" data-mp="n64abl04tmkc" />
        </div>
      </div>
    </section>;
}